// eslint-disable-next-line import/no-anonymous-default-export
export default {
  userManagement: {
    userDetail: "User Detail",
    updatePassword: "Update Password",
    password: "Password",
    associatedCompany: "Associated Companies",
    columns: {
      userName: "User Account",
      email: "Email",
      phoneNumber: "Phone Call",
      lastLoginedAt: "Last Login time",
      lastModifiedAt: "Last Modified time",
    },
    searchPlaceholder: {
      userName: "Please enter user account",
      phoneNumber: "Please enter phone call",
      email: "Please enter email",
    },
  },
};
